import { getField, updateField } from "vuex-map-fields";
import depositNewReq from "./depositNewReq";
import manageDeposit from "./manageDeposit";
import termiUpdat from "./termiUpdat";
import termiUpdatRsultHist from "./termiUpdatRsultHist";

const getDefaultState = () => {
  return {
    depositInfo: {
      groupCoCd: "", //그룹회사코드
      operGroupCd: "", //운영그룹코드
      boPrdctCd: "", //BO상품코드 [AS-IS 상품코드]
      ovsesBrncoPrdctCd: "", //해외BO상품코드 [TO-BE 상품코드]
      prcssDstic: "", //처리구분
      ovsesPpsnCoprDstic: "", //해외개인법인구분코드(//1:개인, 2:법인)
      productInfo: {
        prdctHanglName: "",
        prdctEngName: "",
        prdctLcalName: "",
        prdctBrifHanglCtnt: "",
        prdctBrifEngCtnt: "",
        prdctBrifLcalCtnt: "",
        prdctIrtBrifHanglCtnt: "",
        prdctIrtBrifEngCtnt: "",
        prdctIrtBrifLcalCtnt: "",
      },
    },
  };
};

const deposit = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getDepositInfo: state => {
      return state.depositInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setDepositInfo: (state, payload) => {
      state.depositInfo = payload;
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("depositNewReq/resetState");
      commit("termiUpdat/resetState");
      commit("termiUpdatRsultHist/resetState");
      commit("manageDeposit/resetState");
    },
    // 예금신규 예비거래 IN
    ACT_setDepositInfo: (context, payload) => {
      context.commit("setDepositInfo", payload);
    },
  },
  modules: {
    depositNewReq,
    termiUpdat,
    termiUpdatRsultHist,
    manageDeposit,
  },
};

export default deposit;
